import * as React from 'react';
import { MessageCard } from '../../designSystem/MessageCard';
import { useParams } from 'react-router-dom';
import { logout } from '../../api/authClientApi';
import { CommandResult } from '../../amorg-common';
import { errorCodes } from '../../amorg-common';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { Card } from '../../designSystem/Card';
import { confirmUserCreation } from '../../api/userClientApi';
import { PageHeader } from '../../designSystem/PageHeader';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';

export default function ConfirmCreateUserPage(): JSX.Element
{
    return (
        <UserPageWrapper breadCrumbs={[{ text: 'Bekræft oprettelse af bruger', url: '' }]}>
            <ConfirmCreateUserPageContent />
        </UserPageWrapper>
    );
}

function ConfirmCreateUserPageContent(): JSX.Element
{
    const [state, setState] = React.useState<{hasExecuted:boolean, result?:CommandResult}>(
        {
            hasExecuted:false,
            result:undefined
        }
    );

     const params = useParams<{siteId:string, userId:string, requestId:string}>();

     const activeUser = React.useContext(ProtectedPageContext).user;
     const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['CreateUser']);

     React.useEffect(() => {
        const getData = async () => {
            const result = await confirmUserCreation(params.siteId, params.userId, params.requestId);
            if(result.isSuccess){
                await logout();
            }
            else{
                console.log(result.errorMessage);
            }
            setState({ hasExecuted:true, result});
		};
		getData();
    }, []);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
        <PageHeader headerText="Bekræft oprettelse af bruger" narrow />

        <SingleColumnLayout narrow>
            <>
                <div style={{margin:'30px auto', width:'50%', maxWidth:'600px'}}>
                    
                    <Card variant="outlined">
                        {state.hasExecuted &&
                            <Result value={state.result as CommandResult} />
                        }
                    </Card>
                </div>
            </>
        </SingleColumnLayout>
        </>
    );
}

type ResultProps = { value:CommandResult }
function Result({value: result}:ResultProps):JSX.Element
{
    const messageType = result.isSuccess ? 'success' : 'error';
    return(
        <>
            {result.isSuccess
                ? <MessageCard variant={messageType}>Brugeren er oprettet. Log ind fra hovedmenuen.</MessageCard>
                : getErrorMessage(result.errorMessage)
            }
        </>
    );

    function getErrorMessage(error:errorCodes)
    {
        switch(error){
            case 'invalid_site': 
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_invalid_requestId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_invalid_userId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_no_requests_exist':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Dette kan bl.a. skyldes at der er gået for lang tid siden du forsøgte at oprette brugeren, eller at brugeren allerede er aktiveret..</MessageCard>
            case 'confirmUserCreation_userId_in_use':
                return <MessageCard variant={'error'}>Linket er ikke længere gyldigt. Du kan oprette en ny bruger fra login panelet.</MessageCard>
            case 'confirmUserCreation_email_in_use':
                return <MessageCard variant={'error'}>En bruger er allerede oprettet med den indtastede email addresse.</MessageCard>
            default:
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
        }
    }
}